const APP_ELEMENT_ID = 'otbc';

const APP_WEB_COMPONENT_NAME = 'dh-io-otbc';

enum VEHICLE_TYPE {
  CAR = 'car',
  VAN = 'van',
}

const CONTEXT = 'OWPC';

enum QUERY_PARAMETERS {
  DEALER = 'dealer',
  CONTEXT = 'context',
  MODEL_SERIES = 'modelSeries',
}

enum VEHICLE_CATEGORY {
  COMMERCIAL = 'COMMERCIAL',
  PRIVATE = 'PRIVATE',
}

const SEARCH_PROFILE = {
  COMMERCIAL: 'OTB_VANS',
  PRIVATE: 'MB_PC_Sales',
  PRIVATE_AND_COMMERCIAL: 'OTB_PC_VANS',
};

enum HTTP_HEADERS {
  REQUEST_ID = 'request-id',
  JOURNEY_ID = 'journey-id',
  AUTORIZATION = 'authorization',
}

const IMAGE_REGEX = {
  WIDTH: /(width|WIDTH)=\d{3}/,
  ROTATION: /(pov|POV)=BE\d{3}/,
};

enum LANG_DIRECTION {
  RTL = 'rtl',
  LTR = 'ltr',
}

/**
 * RENT TIME DEFAULT VALUES IN MINUTES
 */
const RENTAL_DEFAULT_MIN_DURATION = 120;
const RENTAL_DEFAULT_TIMESLOT_INTERVAL = 30;

enum REQUEST_ANSWERS {
  PENDING = 'PENDING',
}

const RTL_LANGUAGES = ['ar'];

const SKELETON_HEIGHT_SIZE = new Map([
  ['heading-xxl', 'height: 4.5rem;'],
  ['heading-xl', 'height: 4rem;'],
  ['heading-l', 'height: 3rem;'],
  ['heading-m', 'height: 2.125rem;'],
  ['heading-s', 'height: 1.5rem;'],
  ['heading-xs', 'height: 1.25rem;'],
  ['copy', 'height: 1.125rem;'],
  ['copy-secondary', 'height: 1rem;'],
  ['copy-tertiary', 'height: .875rem;'],
  ['hint', 'height: .75rem;'],
  ['button-l', 'height: 4rem;'],
  ['button-m', 'height: 3rem;'],
  ['button-s', 'height: 2.5rem;'],
  ['image', 'height: 10rem;'],
]);

const SKELETON_WIDTH_SIZE = new Map([
  ['full', 'width: 100%;'],
  ['3xl', 'width: 50rem;'],
  ['xxl', 'width: 30rem;'],
  ['xl', 'width: 20rem;'],
  ['l', 'width: 16rem;'],
  ['m', 'width: 12rem;'],
  ['s', 'width: 10rem;'],
  ['xs', 'width: 8rem;'],
  ['xxs', 'width: 5rem;'],
  ['3xs', 'width: 3rem;'],
]);

//ADD TO THIS AS NEEDED

enum SCREEN_HEIGHT_SIZE {
  SMALL = 768,
}

enum TRACKING_EVENT_ACTION {
  CANCELLATION_MOTIVE = 'select_cancellation_motive',
  CANCELLATION = 'test_drive_cancellation',
  GENERAL = 'test_drive',
  RESCHEDULE = 'test_drive_reschedule',
  CALENDAR_REQUEST = 'calendar_request',
  VEHICLE_CARD = 'test_drive_vehicle_card',
  RESULTS = 'test_drive_results',
  CALENDAR_BOOKING = 'calendar_booking',
  NO_BOOKINGS_AVAILABLE = 'no_bookings_available',
  MME_LOGIN = 'mme_login',
  FORM = 'test_drive_form',
  SHOW_FILTERS = 'show_filters',
  FILTER_RESULTS = 'results',
  VEHICLE = 'vehicle',
  PERIOD = 'period',
  RETAILER = 'retailer',
  REQUEST_FLOW = 'request_flow',
  SEARCH_EXECUTED = 'search_executed',
  FIND_TEST_DRIVE = 'find_test_drive',
}

enum TRACKING_EVENT_CATEGORY {
  FEATURE = 'feature',
  LINK = 'link',
  IMPRESSION = 'impression',
  FORM = 'form',
  FILTER = 'filter',
  SEARCH = 'search',
}

enum TRACKING_EVENT_LABEL {
  BUY_VEHICLE = 'buy_vehicle',
  CANCELLATION_INIT = 'cancel',
  CANCELLATION_CONFIRM = 'confirm',
  CANCELLATION_LEAVE = 'leave',
  RESCHEDULE_INIT = 'reschedule',
  RESCHEDULE_CONFIRM = 'confirm_the_reschedule',
  RESCHEDULE_LEAVE = 'cancel',
  SEE_DOCUMENTS = 'see_documents',
  CALENDAR_SELECT_DATE = 'select_date',
  CALENDAR_SELECT_TIME = 'select_time',
  CALENDAR_CANCEL = 'cancel',
  CALENDAR_APPLY = 'apply',
  CALENDAR_CONFIRM = 'confirm',
  VEHICLE_CARD_INFO = 'info',
  VEHICLE_CARD_BOOKING = 'proceed_booking',
  BOOKING_NOT_AVAILABLE = 'booking_option_not_available',
  BOOKING_AVAILABLE = 'booking_option_available',
  CONTINUE_WITH_REQUEST = 'continue_with_request',
  FORM_SENT = 'form_sent',
  CLEAR_ALL = 'clear_all',
  FUEL = 'fuel',
  TRANSMISSION = 'transmission',
  ENGINE = 'engine',
  SELECT_DEALER = 'select_dealer',
  CALENDAR = 'calendar',
  CONTACT_FORM = 'contact_form',
  LOCATION = 'location',
  DISTANCE_AND_UNIT = 'distance_and_unit',
  DATE_INTERACTION = 'date_interaction',
  TEST_DRIVE_FROM_HOME = 'test_drive_from_home',
}

enum TRACKING_EVENT_TYPE {
  CLICK = 'click',
  PAGEVIEW = 'pageview',
  GLOBAL = 'global',
}

enum TRACKING_EVENT_NAME {
  SELECT_TIMESLOT = 'select_timeslot',
  FORM_SUBMIT = 'form_submit',
  APPLY_FILTER = 'apply_filter',
  FEATURE = 'feature',
  EXECUTE_SEARCH = 'execute_search',
}

enum TRACKING_PAGE_TYPE {
  TEST_DRIVE = 'test_drive',
}

enum TRACKING_PAGE_NAME {
  SCHEDULE_FORM = 'online-testdrive.schedule_form',
  SEARCH = 'online-testdrive.find_your',
  BOOKING_RESULTS = 'online-testdrive.results',
  BOOKING_FORM = 'online-testdrive.booking_form',
  BOOKING_SUMMARY = 'online-testdrive.summary',
}

enum TRACKING_FORM_TYPE {
  STANDARD = 'standard',
  BOOKING = 'booking',
  REQUEST = 'request',
}

enum BROWSER {
  CHROME = 'chrome',
  FIREFOX = 'firefox',
  SAFARI = 'safari',
  OPERA = 'opera',
  EDGE = 'edge',
}

const TRACKING_VEHICLE_SUBBRAND_SEPARATOR = '|';

const MODEL_TYPE_URL_SEPARATOR = ',';

const UTM_PARAMETERS_REGEXP =
  /(utm_campaign|utm_content|utm_medium|utm_source|utm_term)/;

const PROFILE_TYPE = 'CONSUMER';

const MONTHS_TO_CALL = 3;

enum CALENDAR_TYPE {
  NORMAL = 'normal',
  MODAL = 'modal',
}

enum TitleOneDoc {
  DR = 'Dr.',
  PROF = 'Prof.',
  PROF_DR = 'Prof. Dr.',
}

declare interface EnumEntriesValue {
  key: string;
  value: string;
}

declare interface EnumEntries {
  [index: number]: EnumEntriesValue;
}

export {
  APP_ELEMENT_ID,
  APP_WEB_COMPONENT_NAME,
  BROWSER,
  CONTEXT,
  HTTP_HEADERS,
  IMAGE_REGEX,
  LANG_DIRECTION,
  MODEL_TYPE_URL_SEPARATOR,
  RENTAL_DEFAULT_MIN_DURATION,
  RENTAL_DEFAULT_TIMESLOT_INTERVAL,
  REQUEST_ANSWERS,
  RTL_LANGUAGES,
  SKELETON_HEIGHT_SIZE,
  SKELETON_WIDTH_SIZE,
  TRACKING_EVENT_ACTION,
  TRACKING_EVENT_CATEGORY,
  TRACKING_EVENT_LABEL,
  TRACKING_EVENT_TYPE,
  TRACKING_EVENT_NAME,
  TRACKING_PAGE_TYPE,
  TRACKING_PAGE_NAME,
  TRACKING_FORM_TYPE,
  TRACKING_VEHICLE_SUBBRAND_SEPARATOR,
  VEHICLE_TYPE,
  SEARCH_PROFILE,
  SCREEN_HEIGHT_SIZE,
  UTM_PARAMETERS_REGEXP,
  PROFILE_TYPE,
  MONTHS_TO_CALL,
  CALENDAR_TYPE,
  TitleOneDoc as TitleOneDocEnum,
  EnumEntries,
  QUERY_PARAMETERS,
  VEHICLE_CATEGORY,
};
